import React from 'react';
import { EditButton, Datagrid, TextField, DateField, Filter, ReferenceInput, SelectInput, DateInput } from 'react-admin';
import TList from '../../components/wrapper/TList';
import PropTypes from 'prop-types';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import { coreWalletVatTypesForSelection } from './VatDefinitionConstants';
import { countriesForSelection } from '../../i18n/en.js';

const subsidiaryRenderer = choice => `${choice.name} (${choice.id})`;

const VatDefinitionFilter = ({
	vatTypesForSelection,
	...props
}) => (
	<Filter {...props}>
		<ReferenceInput alwaysOn source="subsidiaryId" reference="subsidiaries">
			<SelectInput optionText={subsidiaryRenderer} resettable />
		</ReferenceInput>
		<SelectInput alwaysOn resettable choices={vatTypesForSelection} source="vatType" label="resources.vatDefinitions.filter.vatType" />
		<SelectInput alwaysOn resettable choices={countriesForSelection} source="countryCode" label="resources.vatDefinitions.filter.countryCode" />
		<DateInput
			alwaysOn
			source="validFrom"
			label="resources.vatDefinitions.filter.validFrom"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			alwaysOn
			source="validUntil"
			label="resources.vatDefinitions.filter.validUntil"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
	</Filter>
);

const VatDefinitionList = ({
	vatTypesForSelection,
	...props
}) => (
	<TList
		exporter={false}
		{...props}
		sort={{ field: 'creationDateTime', order: 'DESC' }}
		filters={<VatDefinitionFilter
			vatTypesForSelection={vatTypesForSelection}
			/>
		}
	>
		<Datagrid>
			<EditButton />
			<TextField source="id" sortable={false} />
			<DateField source="creationDateTime" showTime sortable={false} />
			<TextField source="subsidiaryId" sortable={false} />
			<TextField source="vatType" sortable={false} />
			<TextField source="countryCode" sortable={false} />
			<TextField source="vatRate" sortable={false} />
			<DateField source="validFrom" showTime sortable={false} />
			<TextField source="description" sortable={false} />
		</Datagrid>
	</TList>
);

VatDefinitionList.propTypes = {
	vatTypesForSelection: PropTypes.array.isRequired
};
VatDefinitionList.defaultProps = {
	vatTypesForSelection: coreWalletVatTypesForSelection
};

export default VatDefinitionList;
